module.exports = __webpack_public_path__ + "static/media/logo.e9f7dd5f.png";